<nz-select [nzDropdownMatchSelectWidth]="false" [nzShowArrow]="false" (ngModelChange)="changeLang($event)" [(ngModel)]="selectedLang" [nzOptions]="langs"></nz-select>
